import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NiOptionComponent, NiOption } from '../ni-option/ni-option.component';

@Component({
  selector: 'NiFormMoremenu, ni-moremenu',
  templateUrl: './ni-moremenu.component.html',
  styleUrls: ['./ni-moremenu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NiOptionComponent]
})
export class NiMoremenuComponent {
  @Input() options: NiOption[] = [];
  @Input() multiple: boolean = false;
  @Input() selectedOptions: NiOption[] = [];
  @Input() optionLabel: string | number = 'label';
  @Input() showBadge: boolean = true;

  @Output() optionClick = new EventEmitter<NiOption>();

  isOptionSelected(option: NiOption): boolean {
    if (this.multiple) {
      return this.selectedOptions.some(selected => selected.value === option.value);
    }
    return this.selectedOptions.length > 0 && this.selectedOptions[0].value === option.value;
  }

  onOptionClick(option: NiOption): void {
    this.optionClick.emit(option);
  }

  trackByValue(index: number, option: NiOption): any {
    return option?.value;
  }
} 